<template>
  <div class="container">
    <domain-header
      v-if="!hasPendingDomain"
    >
      <domain-search
        v-model="searchDomainInput"
        :input="value"
        @search="handleSearch()"
      />
    </domain-header>
    <domain-pending
      v-if="hasPendingDomain"
    />
    <transition
      v-if="!hasPendingDomain"
      name="fade"
      mode="out-in"
    >
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DomainHeader from '@/components/DomainRegistration/DomainHeader'
import DomainSearch from '@/components/DomainRegistration/DomainSearch'
import DomainPending from '@/components/DomainRegistration/DomainPending'

export default {
  name: 'DomainRegistration',
  components: {
    DomainHeader,
    DomainSearch,
    DomainPending
  },
  data () {
    return {
      searchDomainInput: '',
      value: ''
    }
  },
  computed: {
    ...mapGetters('domainService', ['hasPendingDomain', 'isSearching'])
  },
  methods: {
    ...mapActions('domainService', ['toggleSearchingStatus', 'setSearchTerm']),
    handleSearch () {
      if (!this.isSearching) {
        this.value = this.searchDomainInput
        this.setSearchTerm(this.searchDomainInput)
        this.toggleSearchingStatus(true)
      }
    }
  }
}
</script>
